/**
 * Search-results "Clear search" control (E20-1228, E20-1598)
 *
 * Impulse's PredictiveSearch element binds the "×" beside the search input to its
 * close() method, which hides the predictive dropdown but never touches the input's
 * value. On the search results page the dropdown is already closed and the input is
 * pre-filled from the query, so the control looks broken — it appears to do nothing.
 *
 * The control is labelled "Clear search" and sits outside the field as a page-level
 * affordance, so it reads as "clear this search", not "clear these characters". Emptying
 * the input alone left the URL, the tab title and every result on screen belonging to the
 * old query (E20-1598) — so it navigates to the bare search route instead, and the whole
 * page agrees again.
 *
 * Scoped to .js-search-clear (search-page context only), so the header's "×" keeps its
 * original close-the-dropdown behavior.
 */
const bindSearchClear = () => {
  const clearButton = document.querySelector('.js-search-clear');
  if (!clearButton) return;

  // Supplied by Liquid via `routes.search_url` rather than hardcoded, so a localized or
  // relocated search route still resolves. Without it there is nowhere safe to send the
  // shopper, so leave the control alone rather than guessing a path.
  const searchUrl = clearButton.dataset.searchUrl;
  if (!searchUrl) return;

  clearButton.addEventListener('click', (event) => {
    // The button sits inside the search form — stop it submitting the empty query, which
    // would land on `?q=` and read as a search for nothing rather than a fresh start.
    event.preventDefault();
    window.location.assign(searchUrl);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSearchClear, { once: true });
} else {
  bindSearchClear();
}
